export default __webpack_public_path__ + "static/media/premium_m_04.535c31fc.jpg";